var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"top-selling-widget project-gallery-wrap"},[_c('slick',{attrs:{"options":_vm.slickOptions}},_vm._l((_vm.images),function(img,index){return _c('div',{key:index},[_c('img',{staticClass:"img-fluid",attrs:{"src":img}})])}),0)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }